(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dona-cortina-product-description"]) return;
  try {
    
  (() => {
    'use strict';

    const ELEMENT_NAME = 'dona-cortina-full-description';
    const SOURCE_SELECTOR = '[data-dc-description-source]';

    const normalizeHeading = (value) => String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

    const isElementHeading = (node, tagName) => (
      node && node.nodeType === Node.ELEMENT_NODE && node.tagName === tagName
    );

    const hasMeaningfulContent = (node) => (
      node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== ''
    );

    class DonaCortinaFullDescription extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.enhanceDescription();
      }

      enhanceDescription() {
        const section = this.closest('[data-dc-product-description-section]');
        const descriptionRoot = section?.querySelector(SOURCE_SELECTOR);

        if (!section || !descriptionRoot || descriptionRoot.dataset.dcDescriptionEnhanced === 'true') return;

        const nodes = Array.from(descriptionRoot.childNodes).filter(hasMeaningfulContent);
        if (!nodes.length) return;

        const firstSectionIndex = nodes.findIndex((node) => isElementHeading(node, 'H3'));
        const introBoundary = firstSectionIndex === -1 ? nodes.length : firstSectionIndex;
        const introSource = nodes.slice(0, introBoundary);
        const titleNode = introSource.find((node) => isElementHeading(node, 'H2')) || this.createFallbackTitle();
        const introNodes = introSource.filter((node) => node !== titleNode);
        const sections = this.collectSections(nodes.slice(introBoundary));

        const layout = document.createElement('div');
        layout.className = 'dc-product-description';
        layout.dataset.imagePosition = this.dataset.imagePosition || 'end';

        const hero = document.createElement('div');
        hero.className = 'dc-product-description__hero';

        titleNode.classList.add('dc-product-description__title');
        titleNode.id ||= `dc-product-description-title-${this.dataset.productId || 'product'}`;
        section.setAttribute('aria-labelledby', titleNode.id);

        const heroBody = document.createElement('div');
        heroBody.className = 'dc-product-description__hero-body';

        const intro = document.createElement('div');
        intro.className = 'dc-product-description__intro';
        const heroEyebrow = document.createElement('p');
        heroEyebrow.className = 'dc-product-description__hero-eyebrow';
        heroEyebrow.textContent = 'Atelier Dona Cortina';
        heroEyebrow.setAttribute('aria-hidden', 'true');
        intro.append(heroEyebrow);
        intro.append(titleNode);
        introNodes.forEach((node) => intro.append(node));
        heroBody.append(intro);

        const mediaTemplate = this.querySelector('[data-dc-description-media="hero"]');
        if (mediaTemplate?.content) {
          heroBody.append(mediaTemplate.content.cloneNode(true));
        } else {
          heroBody.classList.add('dc-product-description__hero-body--without-media');
        }

        hero.append(heroBody);
        layout.append(hero);

        const editorialVideo = section.querySelector('[data-dc-editorial-video]');

        if (sections.length) {
          const sectionGrid = document.createElement('div');
          sectionGrid.className = 'dc-product-description__sections';

          sections.forEach((descriptionSection, index) => {
            const panel = this.createSectionPanel(descriptionSection, index);
            if (editorialVideo && panel.dataset.sectionKind === 'sizing' && !sectionGrid.contains(editorialVideo)) {
              sectionGrid.append(editorialVideo);
            }
            sectionGrid.append(panel);
          });

          if (editorialVideo && !sectionGrid.contains(editorialVideo)) sectionGrid.append(editorialVideo);
          layout.append(sectionGrid);
        } else if (editorialVideo) {
          layout.append(editorialVideo);
        }

        descriptionRoot.append(layout);
        descriptionRoot.classList.add('dc-product-description-host');
        descriptionRoot.dataset.dcDescriptionEnhanced = 'true';
        section.dataset.dcDescriptionReady = 'true';
      }

      createFallbackTitle() {
        const heading = document.createElement('h2');
        heading.textContent = this.dataset.productTitle || '';
        return heading;
      }

      collectSections(nodes) {
        const sections = [];
        let currentSection = null;

        nodes.forEach((node) => {
          if (isElementHeading(node, 'H3')) {
            currentSection = { heading: node, content: [] };
            sections.push(currentSection);
            return;
          }

          if (currentSection) currentSection.content.push(node);
        });

        return sections;
      }

      createSectionPanel(descriptionSection, index) {
        const panel = document.createElement('section');
        const kind = this.classifySection(descriptionSection.heading.textContent, index);
        panel.className = `dc-product-description__panel dc-product-description__panel--${kind}`;
        panel.dataset.sectionKind = kind;

        const panelContent = document.createElement('div');
        panelContent.className = 'dc-product-description__panel-content';

        if (kind === 'material' || kind === 'rooms') {
          const marker = document.createElement('span');
          marker.className = 'dc-product-description__panel-index';
          marker.textContent = kind === 'material' ? '01' : '02';
          marker.setAttribute('aria-hidden', 'true');
          panelContent.append(marker);
        }

        descriptionSection.heading.classList.add('dc-product-description__section-title');
        descriptionSection.heading.id ||= `dc-product-description-section-${this.dataset.productId || 'product'}-${index + 1}`;
        panel.setAttribute('aria-labelledby', descriptionSection.heading.id);

        if (kind === 'sizing') {
          const sizingHeader = document.createElement('div');
          const ratio = document.createElement('span');
          sizingHeader.className = 'dc-product-description__sizing-header';
          ratio.className = 'dc-product-description__sizing-ratio';
          ratio.textContent = '2:1';
          ratio.setAttribute('aria-hidden', 'true');
          sizingHeader.append(ratio, descriptionSection.heading);
          panelContent.append(sizingHeader);
        } else {
          panelContent.append(descriptionSection.heading);
        }

        const body = document.createElement('div');
        body.className = 'dc-product-description__section-body';
        descriptionSection.content.forEach((node) => body.append(node));
        body.querySelectorAll('ul, ol').forEach((list) => list.setAttribute('role', 'list'));
        if (kind === 'specifications') this.enhanceSpecifications(body);
        if (kind === 'sizing') this.enhanceSizing(body, index);
        panelContent.append(body);
        panel.append(panelContent);

        if (kind === 'material' || kind === 'rooms') {
          const detailTemplate = this.querySelector(`[data-dc-description-media="${kind}"]`);

          if (detailTemplate?.content) {
            panel.append(detailTemplate.content.cloneNode(true));
          } else {
            panel.classList.add('dc-product-description__panel--without-media');
          }
        }

        return panel;
      }

      enhanceSpecifications(body) {
        body.querySelectorAll(':scope > ul > li').forEach((item) => {
          const label = item.querySelector(':scope > strong');
          if (!label || item.querySelector(':scope > .dc-product-description__specification-value')) return;

          const value = document.createElement('span');
          value.className = 'dc-product-description__specification-value';

          Array.from(item.childNodes).forEach((node) => {
            if (node !== label) value.append(node);
          });

          item.append(value);
        });
      }

      enhanceSizing(body, index) {
        const link = body.querySelector('a[href^="#dc-opening-width-"]');
        if (!link) return;

        const action = link.closest('p');
        const copy = Array.from(body.children).find((node) => node.tagName === 'P' && node !== action);

        if (copy) {
          copy.classList.add('dc-product-description__sizing-copy');
          copy.id ||= `dc-product-description-sizing-copy-${this.dataset.productId || 'product'}-${index + 1}`;
          link.setAttribute('aria-describedby', copy.id);
        }

        if (action) action.classList.add('dc-product-description__sizing-action');

        link.removeAttribute('style');
        link.classList.add('dc-product-description__sizing-link');
        link.dataset.dcCalculatorLink = 'true';
        link.addEventListener('click', (event) => this.navigateToCalculator(event));
      }

      navigateToCalculator(event) {
        const link = event.currentTarget;
        const targetId = decodeURIComponent(link.hash.slice(1));
        const target = document.getElementById(targetId);
        const calculator = target?.closest('[data-dc-size-calculator][data-dc-calculator-surface="inline"]');

        if (!target || !calculator) return;

        event.preventDefault();

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (calculator.tagName === 'DETAILS') calculator.open = true;
        calculator.setAttribute('aria-expanded', 'true');

        if (window.location.hash !== link.hash) {
          window.history.pushState(null, '', link.hash);
        }

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            calculator.classList.remove('dc-size-calculator--arrived');

            target.scrollIntoView({
              behavior: reduceMotion ? 'auto' : 'smooth',
              block: 'center',
              inline: 'nearest'
            });

            let focusCompleted = false;
            let scrollEndHandler;
            const focusTarget = () => {
              if (focusCompleted) return;
              focusCompleted = true;
              if (scrollEndHandler) window.removeEventListener('scrollend', scrollEndHandler);
              target.focus({ preventScroll: true });

              if (!reduceMotion) {
                void calculator.offsetWidth;
                calculator.classList.add('dc-size-calculator--arrived');
                window.setTimeout(() => calculator.classList.remove('dc-size-calculator--arrived'), 1300);
              }
            };

            if (reduceMotion) {
              focusTarget();
              return;
            }

            if ('onscrollend' in window) {
              scrollEndHandler = focusTarget;
              window.addEventListener('scrollend', scrollEndHandler, { once: true });
            }

            const startedAt = window.performance.now();
            let previousScrollY = window.scrollY;
            let stableFrames = 0;

            const waitForScrollToSettle = () => {
              if (focusCompleted) return;

              const elapsed = window.performance.now() - startedAt;
              const currentScrollY = window.scrollY;
              stableFrames = Math.abs(currentScrollY - previousScrollY) < 1 ? stableFrames + 1 : 0;
              previousScrollY = currentScrollY;

              if ((elapsed > 260 && stableFrames >= 5) || elapsed > 1800) {
                focusTarget();
                return;
              }

              window.requestAnimationFrame(waitForScrollToSettle);
            };

            window.requestAnimationFrame(waitForScrollToSettle);
          });
        });
      }

      classifySection(headingText, index) {
        const heading = normalizeHeading(headingText);

        if (
          heading.includes('especifica')
          || heading.includes('ficha tecnica')
          || /detalhes?\s+tecnicos?/.test(heading)
          || heading.includes('dados tecnicos')
        ) return 'specifications';
        if (heading.includes('largura') || heading.includes('medida') || heading.includes('tamanho')) return 'sizing';
        if (heading.includes('personaliza') || heading.includes('abertura') || heading.includes('acabamento')) return 'customization';
        if (heading.includes('onde') || heading.includes('ambiente')) return 'rooms';
        if (
          heading.includes('luz')
          || heading.includes('textura')
          || heading.includes('privacidade')
          || heading.includes('tecido')
          || heading.includes('composicao')
        ) return 'material';
        if (heading.includes('caracteristica') || heading.includes('beneficio') || index === 0) return 'benefits';

        return 'detail';
      }
    }

    if (!customElements.get(ELEMENT_NAME)) {
      customElements.define(ELEMENT_NAME, DonaCortinaFullDescription);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
